<template>
  <div>
    <div class="d-flex">
      <h1 class="mb-3 mr-auto">{{ project.title }}</h1>
      <div class="align-self-center">
        <b-button variant="success" class="mr-2" @click="saveProject">
          <b-spinner v-if="sending" small></b-spinner>
          <i v-else class="far fa-save"></i>
          Sačuvaj
        </b-button>
        <b-button variant="outline-secondary" @click="editCancel">Odustani</b-button>
      </div>
    </div>
    <b-card class="mb-3">
      <b-row>
        <b-col cols md="4">
          <LogoImage
            ref="logo_image"
            :image="project.image"
            :options="logoImageOptions"
            v-on:completedEvent="completedEvent"
            v-on:errorEvent="errorEvent"
          ></LogoImage>
        </b-col>
        <b-col cols md="8">
          <h4 class="card-title">Info</h4>
          <div>
            Grant:
            <b>
              <a
                :href="project.grant && project.grant.website"
                target="_blank"
              >{{ project.grant && project.grant.name}}</a>
            </b>
          </div>
          <div>
            Period:
            <b>{{ startDate | moment('D.M.YYYY') }} - {{ endDate | moment('D.M.YYYY') }}</b>
          </div>
          <div>
            Odobrena sredstva:
            <b>{{ project.budget }}</b>
            {{ project.currency}}
          </div>
          <div class="d-flex">
            <label class="py-2 mr-2">Kategorija</label>
            <b-input v-model="project.category"></b-input>
          </div>
          <div class="d-flex">
            <label class="py-2 mr-2">Lokacija</label>
            <b-input v-model="project.location"></b-input>
          </div>
          <div class="d-flex">
            <label class="py-2 mr-2">Vebsajt</label>
            <b-input v-model="project.website"></b-input>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mb-3" title="Kratak opis projekta">
      <b-textarea v-model="project.about" rows="5" max-rows="10"></b-textarea>
    </b-card>
  </div>
</template>

<script>
import config from "@/config";
import { mapActions, mapGetters, mapMutations } from "vuex";
import LogoImage from "@/components/LogoImage";

export default {
  props: ["project"],
  components: {
    LogoImage
  },
  data() {
    return {
      sending: false,
      oldData: {}
    };
  },
  created() {
    Object.assign(this.oldData, this.project);
  },
  computed: {
    ...mapGetters({
      token: "auth/token"
    }),

    logoImageOptions() {
      return {
        url: config.API_URL + "/projects/" + this.project.id + "/logo",
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
    },
    startDate() {
      return this.project.start_date ? this.project.start_date : new Date();
    },
    endDate() {
      return this.project.end_date ? this.project.end_date : new Date();
    }
  },
  methods: {
    ...mapActions({
      updateProject: "project/update"
    }),
    ...mapMutations({
      setProjectImage: "project/SET_IMAGE"
    }),
    completedEvent(file, response) {
      this.setProjectImage(response);
      this.oldData.image = response;
      this.makeToast(
        "success",
        "Logo sačuvan",
        "Novi logo projekta je sačuvan."
      );
    },
    errorEvent(file, response) {
      this.$refs.logo_image.addImage({
        src: this.project.image,
        progress: 100,
        completed: true
      });
      this.makeToast("danger", "Greška", "Došlo je do greške priliom slanja.");
    },
    saveProject() {
      if (!/^https?:\/\//i.test(this.project.website)) {
        this.project.website = "http://" + this.project.website;
      }
      this.sending = true;
      this.updateProject()
        .then(res => {
          this.$emit("project-saved");
        })
        .catch(err => {
          this.makeToast(
            "danger",
            "Greška!",
            "Došlo je do greške prilikom slanja."
          );
        })
        .then(() => {
          this.sending = false;
        });
    },
    editCancel() {
      Object.assign(this.project, this.oldData);
      this.$emit("cancel-edit");
    }
  }
};
</script>

<style>
</style>